module.exports = __webpack_public_path__ + "img/accenture-white.6180b1fb.png";